import amplitude from 'amplitude-js';

const normalizeParams = (params,) => {
  const normalized = {};
  Object.keys({ ...params, },).forEach((key,) => {
    if (params[key] === undefined || params[key] === null) {
      return;
    }
    normalized[key] = String(params[key],).toUpperCase();
  },);
  return normalized;
};

const isProduction = process.env.NODE_ENV === 'production';

export default {
  install: function (Vue, userId,) {
    const instance = amplitude.getInstance();

    instance.init(process.env.VUE_APP_AMPLITUDE_API_KEY,);

    if (userId) {
      instance.setUserId(userId,);
    }

    Vue.prototype.$amplitude = {
      ...instance,
      identify: (key, value,) => {
        if (!isProduction) {
          return;
        }

        let identify = new amplitude.Identify().set(key, value,);
        return instance.identify(identify,);
      },
      logEvent: (eventName, params,) => {
        if (!isProduction) {
          return;
        }

        return instance.logEvent(eventName, {
          ...normalizeParams(params,),
          production: isProduction,
        },);
      },
    };
  },
};
